// Text matching shared by the search boxes (hamburger menu, quest picker).
//
// A query typed in the wrong keyboard layout still matches: besides the text
// as typed, every query is also tried with each character swapped between
// QWERTY and ЙЦУКЕН, so "crjkmrj" finds "Сколько" and "ешфме" finds "Tivat".

const EN = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:"ZXCVBNM<>?~@#$^&';
const RU = 'йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё"№;:?';

const swapMap = new Map();
[...EN].forEach((ch, i) => {
  swapMap.set(ch, RU[i]);
  if (!swapMap.has(RU[i])) swapMap.set(RU[i], ch);
});

export const swapLayout = (s) => [...String(s || '')].map((ch) => swapMap.get(ch) || ch).join('');

export const normalize = (s) => String(s || '').toLowerCase().replace(/ё/g, 'е');

// makeMatcher(query) -> (fields) -> score, 0 when nothing matches.
// `fields` is the list of strings a row can be found by; the first one is
// its visible label and gets the bonus for starting with / containing the
// query. A hit through the swapped layout scores below a direct one.
export const makeMatcher = (query) => {
  const typed = normalize(query).split(/\s+/).filter(Boolean);
  if (!typed.length) return () => 0;
  const variants = [{ words: typed, weight: 10 }];
  const swapped = typed.map((w) => normalize(swapLayout(w)));
  if (swapped.join(' ') !== typed.join(' ')) variants.push({ words: swapped, weight: 0 });

  return (fields) => {
    const norm = (fields || []).map(normalize);
    const label = norm[0] || '';
    const hay = norm.join(' ');
    let best = 0;
    variants.forEach(({ words, weight }) => {
      if (!words.every((w) => hay.includes(w))) return;
      const first = words[0];
      const score = 1 + weight + (label.startsWith(first) ? 2 : label.includes(first) ? 1 : 0);
      if (score > best) best = score;
    });
    return best;
  };
};
